export default "__VITE_ASSET__DKOejm4y__"